import DisclosurePanel from "./DisclosurePanel";

export default DisclosurePanel;
